import { tabs } from '../../../../../../views/dashboard/service-provider';

export default {
  tabs: {
    [tabs.general]: 'Generelt',
    [tabs.restaurant_details]: 'Restaurantdetaljer',
    [tabs.order_conversion]: 'Ordrekonvertering',
    [tabs.external_delivery]: 'Ekstern levering',
    [tabs.mobile_app]: 'Mobilapp',
    [tabs.customer_success_team]: 'Customer success-team',
    [tabs.onboarding_team]: 'Onboarding-team',
  },
  date_range: {
    this_month: 'Denne måned',
    last_month: 'Sidste måned',
    last_week: 'Sidste uge',
    last_year: 'Sidste år',
    this_week: 'Denne uge',
    this_year: 'I år',
    today: 'I dag',
    yesterday: 'I går',
    all: 'Alle',
  },
};
